import { Injectable } from "@angular/core";
import { CoreMasterDataService } from "../core-masterdata.service";
import { HttpClient } from "@angular/common/http";

import { Observable, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AwaitingMoreInfoService extends CoreMasterDataService {
  constructor(private http: HttpClient) {
    super(http, "reasons");
  }

  getAwaitingMoreInfoReasons(): Observable<any[]> {
    const tenantId = Number(localStorage.getItem("tenant"));
    const url = `${this.base_url}/awaiting-more-info/${tenantId}`;
    return this.http.get<any[]>(url, { headers: this.headers }).pipe(
      tap(() => this.log("Fetched awaiting more info reasons")),
      catchError(this.handleError("getAwaitingMoreInfoReasons", []))
    );
  }

  deleteAwaitingMoreInfoReason(id: number): Observable<any> {
    const url = `${this.base_url}/awaiting-more-info/${id}`;
    return this.http
      .delete<any>(url, {
        responseType: "text" as "json",
        headers: this.headers,
      })
      .pipe(
        tap(() => this.log("Deleted more info reasons")),
        catchError(this.handleError("DeletedAwaitingMoreInfoReasons", []))
      );
  }

  editAwaitingMoreInfoReason(id: number, data: any): Observable<any> {
    const url = `${this.base_url}/${id}`;
    return this.http.put<any[]>(url, data, { headers: this.headers }).pipe(
      tap(() => this.log("Edited more info reasons")),
      catchError(this.handleError("EditedAwaitingMoreInfoReasons", []))
    );
  }

  addAwaitingMoreInfoReason(data: any): Observable<any> {
    const url = `${this.base_url}/awaiting-more-info`;
    return this.http
      .post<any[]>(url, data, {
        responseType: "text" as "json",
        headers: this.headers,
      })
      .pipe(
        tap(() => this.log("Edited more info reasons")),
        catchError(this.handleError("EditedAwaitingMoreInfoReasons", 500))
      );
  }
}
